import React from 'react';
import { StripeAccountChangeConfirmation } from 'fitbeat.react-native-components';
import { HomeCarouselAuthLayout } from './Layouts/HomeCarouselAuthLayout';

export const StripeAccountChangeConfirmationContainer = (props) => {
  return (
    <HomeCarouselAuthLayout header={'Account Change'} hasAccessToAStudioGym={false} {...props}>
      <StripeAccountChangeConfirmation {...props}/>
    </HomeCarouselAuthLayout>
  );
};
